import {ChangeDetectionStrategy, Component, computed, Signal, signal, viewChild, WritableSignal} from "@angular/core";
import {navParam} from "../../navigation/navigation-params";
import {Page} from "../../navigation/page";
import {FormComponent} from '../../inputs/form/form.component';
import {TextFieldComponent} from '../../inputs/text-field/text-field.component';
import {ModalPageLayoutComponent} from '../../page-layout/modal-page-layout/modal-page-layout.component';
import {FormsModule} from '@angular/forms';
import {ButtonComponent} from '../../buttons/button/button.component';
import {PageFooterControlDirective} from '../../page-layout/page-footer-control.directive';

@Component({
    selector: "woa-waiter-name-edit-page",
    templateUrl: "./waiter-name-edit-page.component.html",
    styleUrl: "./waiter-name-edit-page.component.scss",
    providers: [{provide: Page, useExisting: WaiterNameEditPageComponent}],
    imports: [
        ButtonComponent,
        FormComponent,
        FormsModule,
        ModalPageLayoutComponent,
        PageFooterControlDirective,
        TextFieldComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WaiterNameEditPageComponent extends Page {
    public readonly form: Signal<FormComponent> = viewChild.required(FormComponent);

    public readonly name: WritableSignal<string> = navParam<string>("name");
    private readonly nameSpecified: Signal<boolean> = signal(!!this.name());

    public readonly title: Signal<string> = computed(() =>
        this.nameSpecified() ? "woa.heading.editWaiterName.change" : "woa.heading.editWaiterName.enter");

    public readonly buttonLabel: Signal<string> = computed(() =>
        this.nameSpecified() ? "woa.button.common.change" : "woa.button.common.proceed");

    confirmName(): void {
        if (!this.form().valid) {
            return;
        }

        void this.dismiss(this.name());
    }
}
